import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX, FiCalendar } from "react-icons/fi";

export default function AddCertificationModal({ show, onHide }) {
  const [form, setForm] = useState({});

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      
      {/* HEADER */}
      <div
        style={{
          padding: "15px 20px",
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h5 style={{ fontWeight: 600 }}>Add Certification</h5>

        <div
          onClick={onHide}
          style={{
            width: 30,
            height: 30,
            borderRadius: "50%",
            background: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <FiX />
        </div>
      </div>

      {/* BODY */}
      <Modal.Body style={{ padding: 20 }}>

        {/* SELECTS */}
        {[
          "Employee Name",
          "Designation",
          "Training Type",
          "Trainer Name",
        ].map((label, i) => (
          <div key={i} style={{ marginBottom: 15 }}>
            <Form.Label>
              {label} <span style={{ color: "red" }}>*</span>
            </Form.Label>

            <Form.Select style={inputStyle}>
              <option>Select</option>
            </Form.Select>
          </div>
        ))}

        {/* DATE ROW */}
        <div style={{ display: "flex", gap: 15, flexWrap: "wrap" }}>
          <DateInput label="Start Date" />
          <DateInput label="Completion Date" />
        </div>

        {/* ISSUE DATE */}
        <DateInput label="Certificate Issue Date" full />
      </Modal.Body>

      {/* FOOTER */}
      <div
        style={{
          padding: 15,
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
        }}
      >
        <Button
          onClick={onHide}
          style={{
            background: "#eee",
            border: "none",
            color: "#333",
          }}
        >
          Cancel
        </Button>

        <Button
          style={{
            background: "#f97316",
            border: "none",
          }}
        >
          Add Certification
        </Button>
      </div>
    </Modal>
  );
}

/* DATE INPUT WITH CALENDAR */
function DateInput({ label, full }) {
  return (
    <div style={{ flex: full ? "100%" : 1, marginBottom: 15 }}>
      <Form.Label>
        {label} <span style={{ color: "red" }}>*</span>
      </Form.Label>

      <div style={{ position: "relative" }}>
        <input
          type="date"
          style={{
            ...inputStyle,
            width: "100%",
            paddingRight: 35,
          }}
        />

     
      </div>
    </div>
  );
}

const inputStyle = {
  background: "#f9fafb",
  border: "1px solid #e5e7eb",
  borderRadius: 6,
  padding: "10px",
};